// extracted by mini-css-extract-plugin
module.exports = {"next-sr-only":"UploadImage--next-sr-only--1jdWYY2","uploadButtonWrapper":"UploadImage--uploadButtonWrapper--3r22DjW","uploadButton":"UploadImage--uploadButton--3VW-Squ"};